import EmptyWallet from './emptyWallet.png';
import fullWallet from './fullWallet.jpg';
import { colors } from '../../../colors';
import { useDimensions } from '../../../hooks/useDimensions';

const Expactations = () => {
  const { dimensions: rootDimensions, ref: rootRef } = useDimensions();

  const chartWidth = ((rootDimensions?.width ?? 0) / 2) * 0.7;

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        width: '100%',
        justifyContent: 'space-evenly',
      }}
      ref={rootRef}
    >
      <div
        style={{
          width: '50%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            color: colors.white,
            fontSize: 28,
            margin: 0,
            marginBottom: 30,
          }}
        >
          No expectations
        </p>
        <img
          src={EmptyWallet}
          width={chartWidth}
          height={(rootDimensions?.height ?? 0) * 0.8}
        />
      </div>
      <div
        style={{
          width: '50%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            color: colors.white,
            fontSize: 28,
            margin: 0,
            marginBottom: 30,
          }}
        >
          Long term view
        </p>
        <img
          src={fullWallet}
          width={chartWidth}
          height={(rootDimensions?.height ?? 0) * 0.8}
        />
      </div>
    </div>
  );
};

export default Expactations;
